import { ExecutionRequestData } from "./ExecutionRequestData"/* tslint:disable */



export class ApiExecutionRequest {
		DecisionServiceId: number;
		VersionNumber: number;
		Reference: string;

		ExecutionRequestData: ExecutionRequestData[];
		ExecutionRequestMetaData: ExecutionRequestData[];
}




// WEBPACK FOOTER //
// D:/a/1/s/src/services/generated/models/ApiExecutionRequest.ts